import { Body2, UIHeading4, UIHeading5 } from '@cian/ui-kit';
import * as React from 'react';

import replyOnboardingIcon from './assets/reply-onboarding.svg';
import styles from './ReplyOnboardingTooltip.css';

interface IReplyOnboardingTooltipContentProps {
  onClose: VoidFunction;
}

export const ReplyOnboardingTooltipContent: React.FC<IReplyOnboardingTooltipContentProps> = ({ onClose }) => (
  <div className={styles['content']} data-testid="ReplyOnboardingTooltip">
    <img className={styles['icon']} src={replyOnboardingIcon} width={40} height={40} alt="" />

    <div className={styles['body']}>
      <div className={styles['text']}>
        <UIHeading4 color="text-inverted-default">Добавили «ответы»</UIHeading4>
        <Body2 color="text-inverted-default">
          Кликните правой кнопкой по сообщению и выберите «Ответить», чтобы процитировать сообщение
        </Body2>
      </div>

      <button className={styles['button']} type="button" onClick={onClose} data-testid="ReplyOnboardingTooltipButton">
        <UIHeading5 color="text-inverted-default">Супер!</UIHeading5>
      </button>
    </div>
  </div>
);
